<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <fungicide-statistics />
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import FungicideStatistics from '@/components/dashboard/FungicideStatistics.vue'

export default {
  name: 'SupervisorGraphFungicides',

  middleware: ['auth', 'supervisor'],

  components: {
    FungicideStatistics
  },

  metaInfo () {
    return {
      title: 'Fungicides Graph'
    }
  },

  mounted () {
    core.index()
  }

}
</script>
